"use client"

import { usePrivateModeStore } from "@src/stores/usePrivateModeStore"
import { isOnSensitiveRoute } from "@src/utils/analyticsSuppression"
import { usePathname } from "next/navigation"

/** React-reactive version of `isAnalyticsSuppressed()`. Re-renders on change. */
export function useAnalyticsSuppressed(): boolean {
  const isPrivateModeEnabled = usePrivateModeStore(
    (s) => s.isPrivateModeEnabled
  )
  const pathname = usePathname()
  return isPrivateModeEnabled || isOnSensitiveRoute(pathname)
}
